export default "__VITE_ASSET__DFtv7fwP__"